var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4993 2.44922C27.6631 2.44922 31.7333 3.6839 35.1953 5.99713C38.6573 8.31037 41.3556 11.5983 42.9489 15.445C44.5423 19.2918 44.9592 23.5247 44.1469 27.6084C43.3346 31.6921 41.3296 35.4432 38.3854 38.3874C35.4412 41.3316 31.6901 43.3366 27.6064 44.1489C23.5227 44.9612 19.2898 44.5443 15.4431 42.9509C11.5963 41.3575 8.30841 38.6592 5.99518 35.1972C3.68195 31.7352 2.44727 27.665 2.44727 23.5013C2.44986 17.9187 4.66867 12.5656 8.61614 8.6181C12.5636 4.67063 17.9168 2.45181 23.4993 2.44922Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4993 2.44922C27.6631 2.44922 31.7333 3.6839 35.1953 5.99713C38.6573 8.31037 41.3556 11.5983 42.9489 15.445C44.5423 19.2918 44.9592 23.5247 44.1469 27.6084C43.3346 31.6921 41.3296 35.4432 38.3854 38.3874C35.4412 41.3316 31.6901 43.3366 27.6064 44.1489C23.5227 44.9612 19.2898 44.5443 15.4431 42.9509C11.5963 41.3575 8.30841 38.6592 5.99518 35.1972C3.68195 31.7352 2.44727 27.665 2.44727 23.5013C2.44986 17.9187 4.66867 12.5656 8.61614 8.6181C12.5636 4.67063 17.9168 2.45181 23.4993 2.44922Z",
    stroke: "url(#paint0_linear_2297_8761)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.0535V11.2031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.0535V11.2031",
    stroke: "url(#paint1_linear_2297_8761)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1426 25.4883L10.9991 35.3951",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1426 25.4883L10.9991 35.3951",
    stroke: "url(#paint2_linear_2297_8761)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5007 25.9466C24.8526 25.9466 25.9486 24.8506 25.9486 23.4987C25.9486 22.1468 24.8526 21.0508 23.5007 21.0508C22.1487 21.0508 21.0527 22.1468 21.0527 23.4987C21.0527 24.8506 22.1487 25.9466 23.5007 25.9466Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5007 25.9466C24.8526 25.9466 25.9486 24.8506 25.9486 23.4987C25.9486 22.1468 24.8526 21.0508 23.5007 21.0508C22.1487 21.0508 21.0527 22.1468 21.0527 23.4987C21.0527 24.8506 22.1487 25.9466 23.5007 25.9466Z",
    stroke: "url(#paint3_linear_2297_8761)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2297_8761",
    x1: 39.7895,
    y1: -2.49561,
    x2: 5.61922,
    y2: 77.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2297_8761",
    x1: 24.3869,
    y1: 10.0463,
    x2: 19.4019,
    y2: 11.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2297_8761",
    x1: 19.6179,
    y1: 36.0111,
    x2: 5.0409,
    y2: 28.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2297_8761",
    x1: 25.3949,
    y1: 20.4758,
    x2: 21.4216,
    y2: 29.7855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock1);
export default __webpack_public_path__ + "static/media/clock-1.60acbd1bacb8dc1f4d1add3408ecd51c.svg";
export { ForwardRef as ReactComponent };